__turbopack_context__.v({
  "checkoutButton": "GMhiWa_checkoutButton",
  "container": "GMhiWa_container",
  "inclTax": "GMhiWa_inclTax",
  "inclTaxLabel": "GMhiWa_inclTaxLabel",
  "inclTaxValue": "GMhiWa_inclTaxValue",
  "row": "GMhiWa_row",
  "rowLabel": "GMhiWa_rowLabel",
  "rowValue": "GMhiWa_rowValue",
  "rows": "GMhiWa_rows",
  "totalLabel": "GMhiWa_totalLabel",
  "totalRow": "GMhiWa_totalRow",
  "totalValue": "GMhiWa_totalValue",
});
